import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './TextoTransform.css';

class TextoTransform extends Component {
  constructor(props) {
    super(props);

    this.contenido = props.contenido;

    this.jump1 = React.createRef();
    this.jump2 = React.createRef();
  }

  enlacesExternos = bloque => {
    const respuesta = [];

    const partirBloque = bloque.split('[::--::]enlaceExternoStart[::--::]');
    partirBloque.forEach((parteBloque, key) => {
      if (parteBloque.includes('[::--::]enlaceExternoEnd[::--::]')) {
        const partirParteBloque = parteBloque.split('[::--::]enlaceExternoEnd[::--::]');
        const partirEnlace = partirParteBloque[0].split(':::');
        respuesta.push(<a className="fontBold linkAzulAzulClaro" href={partirEnlace[2]} key={key} rel="noopener noreferrer" target="_blank" title={partirEnlace[0]}>{partirEnlace[1]}</a>);

        if (partirParteBloque[1] !== '') { respuesta.push(partirParteBloque[1]); }
      } else if (parteBloque !== '') {
        respuesta.push(parteBloque);
      }
    });

    return respuesta;
  };

  enlacesInternos = bloque => {
    const respuesta = [];

    const partirBloque = bloque.split('[::--::]enlaceInternoStart[::--::]');
    partirBloque.forEach((parteBloque, key) => {
      if (parteBloque.includes('[::--::]enlaceInternoEnd[::--::]')) {
        const partirParteBloque = parteBloque.split('[::--::]enlaceInternoEnd[::--::]');
        const partirEnlace = partirParteBloque[0].split(':::');
        respuesta.push(<Link key={key} rel="noopener noreferrer" target="_blank" title={partirEnlace[0]} to={partirEnlace[2]}><span className="fontBold linkAzulAzulClaro">{partirEnlace[1]}</span></Link>);

        if (partirParteBloque[1] !== '') { respuesta.push(partirParteBloque[1]); }
      } else if (parteBloque !== '') {
        respuesta.push(parteBloque);
      }
    });

    return respuesta;
  };

  handleClickJump = jump => {
    if (jump.currentTarget.id === 'jump1') {
      this.jump1.current.scrollIntoView({ behavior: 'smooth' });
    } else if (jump.currentTarget.id === 'jump2') {
      this.jump2.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  enlacesJumps = bloque => {
    const respuesta = [];

    const partirBloque = bloque.split('[::--::]enlaceJumpStart[::--::]');
    partirBloque.forEach((parteBloque, key) => {
      if (parteBloque.includes('[::--::]enlaceJumpEnd[::--::]')) {
        const partirParteBloque = parteBloque.split('[::--::]enlaceJumpEnd[::--::]');
        const partirEnlace = partirParteBloque[0].split(':::');
        respuesta.push(<span className="fontBold linkAzulAzulClaro" id={partirEnlace[0]} key={key} onClick={this.handleClickJump}>{partirEnlace[1]}</span>);

        if (partirParteBloque[1] !== '') { respuesta.push(partirParteBloque[1]); }
      } else if (parteBloque !== '') {
        respuesta.push(parteBloque);
      }
    });

    return respuesta;
  };

  referencias = (bloque, key) => {
    const referencia = bloque.split(':::');

    let respuesta = '';
    if (referencia[0] === 'jump1') {
      respuesta = <p className="textoJustificado" key={key} ref={this.jump1}>{referencia[1]}</p>;
    } else if (referencia[0] === 'jump2') {
      respuesta = <p className="textoJustificado" key={key} ref={this.jump2}>{referencia[1]}</p>;
    }

    return respuesta;
  };

  code = (bloque, indentacion, key) => {
    let clase = 'codeline';
    let texto = bloque;
    if (bloque.includes('highlight:::')) {
      clase = 'codeline codelineHighlight';
      texto = bloque.substring(12);
    }

    let respuesta = '';
    switch (indentacion) {
      case 1:
        respuesta = <div className={clase} key={key} style={{ paddinfLeft: '10px' }}>&nbsp;&nbsp;{texto}</div>;
        break;
      case 2:
        respuesta = <div className={clase} key={key} style={{ paddinfLeft: '20px' }}>&nbsp;&nbsp;&nbsp;&nbsp;{texto}</div>;
        break;
      case 3:
        respuesta = <div className={clase} key={key} style={{ paddinfLeft: '30px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{texto}</div>;
        break;
      case 4:
        respuesta = <div className={clase} key={key} style={{ paddinfLeft: '40px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{texto}</div>;
        break;
      case 5:
        respuesta = <div className={clase} key={key} style={{ paddinfLeft: '50px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{texto}</div>;
        break;
      case 6:
        respuesta = <div className={clase} key={key} style={{ paddinfLeft: '60px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{texto}</div>;
        break;
      default:
        respuesta = <div className={clase} key={key}>{texto}</div>;
    }

    return respuesta;
  }

  renderContenido() {
    const retorno = [];

    this.contenido.forEach((bloque, key) => {
      const partirBloque = bloque.split('[::-::]');

      switch (partirBloque[0]) {
        case 'parrafo':
          // Compruebo enlace externo
          if (partirBloque[1].includes('[::--::]enlaceExternoStart[::--::]')) {
            const enlace = this.enlacesExternos(partirBloque[1]);
            retorno.push(<p className="textoJustificado" key={key}>{enlace}</p>);

          // Compruebo enlace interno
          } else if (partirBloque[1].includes('[::--::]enlaceInternoStart[::--::]')) {
            const enlace = this.enlacesInternos(partirBloque[1]);
            retorno.push(<p className="textoJustificado" key={key}>{enlace}</p>);

          // Compruebo salto dentro de la página
          } else if (partirBloque[1].includes('[::--::]enlaceJumpStart[::--::]')) {
            const enlace = this.enlacesJumps(partirBloque[1]);
            retorno.push(<p className="textoJustificado" key={key}>{enlace}</p>);
          } else {
            retorno.push(<p className="textoJustificado" key={key}>{partirBloque[1]}</p>);
          }

          break;
        case 'parrafoRef':
          retorno.push(this.referencias(partirBloque[1], key));
          break;
        case 'cita':
          retorno.push(<p className="cita textoJustificado" key={key}>{partirBloque[1]}</p>);
          break;
        case 'titular':
          retorno.push(<h3 className="titular" key={key}>{partirBloque[1]}</h3>);
          break;
        case 'codeStart':
          retorno.push('codeStart[::-::]');
          break;
        case 'codeEnd':
          retorno.push('codeEnd[::-::]');
          break;
        case 'codeBlank':
          if (partirBloque[1].includes('highlight:::')) {
            retorno.push(<div className="codeline codelineHighlight" key={key}>&nbsp;</div>);
          } else {
            retorno.push(<div className="codeline" key={key}>&nbsp;</div>);
          }

          break;
        case 'codeIndent-0':
          retorno.push(this.code(partirBloque[1], 0, key));
          break;
        case 'codeIndent-1':
          retorno.push(this.code(partirBloque[1], 1, key));
          break;
        case 'codeIndent-2':
          retorno.push(this.code(partirBloque[1], 2, key));
          break;
        case 'codeIndent-3':
          retorno.push(this.code(partirBloque[1], 3, key));
          break;
        case 'codeIndent-4':
          retorno.push(this.code(partirBloque[1], 4, key));
          break;
        case 'codeIndent-5':
          retorno.push(this.code(partirBloque[1], 5, key));
          break;
        case 'codeIndent-6':
          retorno.push(this.code(partirBloque[1], 6));
          break;
        default:
          return 'ERROR NOTE';
      }

      return null;
    });

    // Bloques de código para iniciarlos con <code> y cerrarlos con </code>
    const codeStarts = [];
    const codeEnds = [];
    retorno.forEach((bloque, key) => {
      if (bloque === 'codeStart[::-::]') {
        codeStarts.push(key);
      } else if (bloque === 'codeEnd[::-::]') {
        codeEnds.push(key);
      }
    });

    const retornoFinal = [];
    if (codeStarts[0] !== 0) {
      retornoFinal.push(retorno.slice(0, codeStarts[0]));
    }

    for (const [index, numero] of codeStarts.entries()) {
      retornoFinal.push(<code className="codeblock" key={index}>{retorno.slice(numero + 1, codeEnds[index])}</code>);
      retornoFinal.push(retorno.slice(codeEnds[index] + 1, codeStarts[index + 1])); // Si codeStarts[index + 1] no existe sale como undefined y me coje hasta el final, así que perfecto
    }

    return retornoFinal;
  }

  render() {
    return (
      <div>
        {this.renderContenido()}
      </div>
    );
  }
}

export default TextoTransform;
